import GeoJSON from "ol/format/GeoJSON.js";

export default function fromTurf(feat, projection, format) {
    if (!format) {
        format = new GeoJSON();
    }
    var feat1 = format.readFeature(feat, { featureProjection: projection });
    return feat1;
}
